"use client";

import React from "react";
import { ReportData } from "../../model/Report";
import axios, { AxiosResponse, AxiosError } from 'axios';
import PDFViewer from "./PDFViewer";
import AlertDialog from "../../components/alertDialog";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const initialDatas:ReportData[] = [];

const ReportPage = () => {
    const [ datas, setDatas ] = React.useState(initialDatas);
    const [ alertDialogMessage, setAlertDialogMessage ] = React.useState(<></>);
    const [ alertDialogShow, setAlertDialogShow ] = React.useState(false);

    const params = new URLSearchParams(window.location.search);
    const outputCidList = params.getAll("cid");
    const outputYear = params.get("year");
    const outputMonth = params.get("month");

    // データ取得処理
    React.useEffect(() => {
        if(!document.referrer) {
            window.close();
        }
        if (outputYear && outputMonth && outputCidList) {
            const getReportData = async () => {
                try {
                    // URLをレポートデータ取得API
                    const clientIds:string[] = outputCidList.map((cid:string) => 'cid=' + cid);
                    const cidQuery = clientIds.join('&');
                    await axios.get(`${API_BASE_URL}/report?year=${outputYear}&month=${outputMonth}&${cidQuery}`).then((response) => {
                        setDatas(response.data);
                    });
                } catch (error:any) {
                    console.error("データ取得エラー", error);
                    if(error && error.status === 404) {
                        setAlertDialogMessage(<p>当月のレポートデータが存在しません。作成処理中の可能性があるため、時間をおいて再度のダウンロードをお試しください。</p>);
                    } else {
                        setAlertDialogMessage(<p>レポートデータの取得に失敗しました。時間をおいて再度のダウンロードをお試しください。</p>);
                    }
                    setAlertDialogShow(true);
                }
            };
            getReportData();
        }
    }, []);

    return (
        <>
            <PDFViewer outputMonth={{year:Number(outputYear), month:Number(outputMonth)}} datas={datas} />
            <AlertDialog 
                show={alertDialogShow} 
                message={alertDialogMessage}
                okClickFunc={()=>{
                    setAlertDialogShow(false);
                    window.close();
                }}  />
        </>
    );
}

export default ReportPage;